// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NodeId, NodeIdT, verifyNodeId } from "./node-id";

/**
 * A NodeId qualified by a namespace URI and server index.
 */
export class ExpandedNodeIdValue implements flatbuffers.IUnpackableObject<ExpandedNodeIdValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ExpandedNodeIdValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsExpandedNodeIdValue(
    bb: flatbuffers.ByteBuffer,
    obj?: ExpandedNodeIdValue,
  ): ExpandedNodeIdValue {
    return (obj || new ExpandedNodeIdValue()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsExpandedNodeIdValue(
    bb: flatbuffers.ByteBuffer,
    obj?: ExpandedNodeIdValue,
  ): ExpandedNodeIdValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ExpandedNodeIdValue()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  nodeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  namespaceUri(): string | null;
  namespaceUri(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  namespaceUri(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  serverIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startExpandedNodeIdValue(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addNodeId(builder: flatbuffers.Builder, nodeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeIdOffset, 0);
  }

  static addNamespaceUri(builder: flatbuffers.Builder, namespaceUriOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, namespaceUriOffset, 0);
  }

  static addServerIndex(builder: flatbuffers.Builder, serverIndex: number) {
    builder.addFieldInt32(2, serverIndex, 0);
  }

  static endExpandedNodeIdValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_id
    return offset;
  }

  static createExpandedNodeIdValue(
    builder: flatbuffers.Builder,
    nodeIdOffset: flatbuffers.Offset,
    namespaceUriOffset: flatbuffers.Offset,
    serverIndex: number,
  ): flatbuffers.Offset {
    ExpandedNodeIdValue.startExpandedNodeIdValue(builder);
    ExpandedNodeIdValue.addNodeId(builder, nodeIdOffset);
    ExpandedNodeIdValue.addNamespaceUri(builder, namespaceUriOffset);
    ExpandedNodeIdValue.addServerIndex(builder, serverIndex);
    return ExpandedNodeIdValue.endExpandedNodeIdValue(builder);
  }

  unpack(): ExpandedNodeIdValueT {
    return new ExpandedNodeIdValueT(
      this.nodeId() !== null ? this.nodeId()!.unpack() : null,
      this.namespaceUri(),
      this.serverIndex(),
    );
  }

  unpackTo(_o: ExpandedNodeIdValueT): void {
    _o.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    _o.namespaceUri = this.namespaceUri();
    _o.serverIndex = this.serverIndex();
  }

  unpackFields(...fields: string[]): ExpandedNodeIdValueT {
    const t = new ExpandedNodeIdValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_id")) {
      t.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    }
    if (fieldSet.has("namespace_uri")) {
      t.namespaceUri = this.namespaceUri();
    }
    if (fieldSet.has("server_index")) {
      t.serverIndex = this.serverIndex();
    }
    return t;
  }
}

export class ExpandedNodeIdValueT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodeId: NodeIdT | null = null,
    public namespaceUri: string | Uint8Array | null = null,
    public serverIndex: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeId === null || this.nodeId === undefined) {
      throw new Error('Required field "node_id" is not set');
    }
    const nodeId = this.nodeId !== null ? this.nodeId!.pack(builder) : 0;
    const namespaceUri = this.namespaceUri !== null ? builder.createString(this.namespaceUri!) : 0;

    return ExpandedNodeIdValue.createExpandedNodeIdValue(
      builder,
      nodeId,
      namespaceUri,
      this.serverIndex,
    );
  }

  clone(): ExpandedNodeIdValueT {
    const obj = new ExpandedNodeIdValueT();
    obj.nodeId = this.nodeId !== null ? this.nodeId!.clone() : null;
    obj.namespaceUri = this.namespaceUri;
    obj.serverIndex = this.serverIndex;
    return obj;
  }

  equals(other: ExpandedNodeIdValueT): boolean {
    if (this.nodeId !== null && other.nodeId !== null) {
      if (!this.nodeId!.equals(other.nodeId!)) return false;
    } else if (this.nodeId !== other.nodeId) return false;
    if (this.namespaceUri !== other.namespaceUri) return false;
    if (this.serverIndex !== other.serverIndex) return false;
    return true;
  }
}

export function verifyExpandedNodeIdValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 4);
  } finally {
    verifier.popDepth();
  }
}
